/* eslint-disable react/jsx-key */
import React, { useEffect, useMemo, useState } from "react";
import { Column } from "react-table";
import { Text } from "@chakra-ui/react";
import { Session } from "types";
import LazyDataTable from "components/LazyDataTable";
import SessionRow from "./SessionRow";
import { SelectFilter } from "components/LazyFilters";
import { useUser } from "context/user";
import { UserRole } from "types/user";
import { startCase } from "lodash";
import { GetClientFirstNameList, GetClientLastNameList, GetClientUserNameList, GetCommaSeperatedClientList } from "utils/user";
import { useQuery } from "@tanstack/react-query";
import { queryKeys, queryFns } from "repo/sessions";

const SessionsDataTable: React.FC = () => {
  const { user: actor } = useUser()!;
  const { isLoading, error, data } = useQuery({
    queryKey: queryKeys.filters(false),
    queryFn: queryFns.filters
  })

  function getFilterValues(key: string) {
    if (isLoading || error || !data || data[key]) return [];
    return data[key];
  }

  const columns: Column<Session>[] = React.useMemo(() =>
    [
      {
        accessor: "id",
        disableSortBy: true,
        Cell: ({ row: { original } }: any) => (
          <SessionRow session={original} />
        )
      },
      {
        Header: "Title",
        accessor: "title"
      },
      {
        Header: "Date",
        accessor: "start_time"
      },
      {
        accessor: "end_time",
        disableSortBy: true
      },
      {
        Header: "Status",
        id: "status",
        accessor: row => startCase(row.status),
        disableSortBy: true,
        Filter: SelectFilter(data ? data['status'] : []),
        filter: "equals"
      },
      {
        Header: "Organization",
        id: "organization",
        accessor: row => row.coach?.organization?.displayName,
        disableSortBy: true,
        Filter: SelectFilter(data ? data['organization'] : []),

        filter: "equals",
        disableFilters: actor.privs <= UserRole.Coach
      },
      {
        Header: "Client(s) Username",
        id: "client_username",
        accessor: row => GetClientUserNameList(row.participants, row.coach),
        disableSortBy: true
      },
      {
        Header: "Client(s) First",
        id: "client_first_name",
        accessor: row => GetClientFirstNameList(row.participants, row.coach),
        disableSortBy: true
      },
      {
        Header: "Client(s) Last",
        id: "client_last_name",
        accessor: row => GetClientLastNameList(row.participants, row.coach),
        disableSortBy: true
      },
      {
        Header: "Coach First",
        id: "coach_first_name",
        accessor: row => row.coach.first_name,
        disableSortBy: actor.privs <= UserRole.Coach
      },
      {
        Header: "Coach Last",
        id: "coach_last_name",
        accessor: row => row.coach.last_name,
        disableSortBy: actor.privs <= UserRole.Coach
      },
      {
        Header: "Client(s)",
        id: "client_name",
        accessor: row => GetCommaSeperatedClientList(row.participants, row.coach),
        disableSortBy: true,
        Filter: SelectFilter(data ? data['client_name'] : []),
      },
      {
        Header: "Coach",
        id: "coach_name",
        accessor: row => `${row.coach?.first_name} ${row.coach?.last_name}`,
        disableSortBy: true,
        Filter: SelectFilter(data ? data['coach_name'] : []),
        filter: "equals",
        disableFilters: actor.privs <= UserRole.Coach
      }
    ], [data, actor.privs]) ;

  return ((isLoading || error) ?
    <Text> Loading...</Text> :
    <LazyDataTable columns={columns} dataKey={queryKeys.data(false)} dataFn={queryFns.data} tableTitle="Sessions" />
  );
};

export default SessionsDataTable;
